import { useState } from 'react';
import { FiShoppingCart } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { cartCount } = useCart();
  const toggleMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div onClick={() => { navigate('/'); setMobileMenuOpen(false); }} className="logo">
        <img src='/images/logo.png' alt="Logo" />
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        &#9776;
      </div>

      <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
        <li>
          <a href="/#about" onClick={() => setMobileMenuOpen(false)}>About</a>
        </li>

        <li onClick={() => { navigate('/products'); setMobileMenuOpen(false); }}>Products</li>
        <li>
          <a href="/" onClick={() => setMobileMenuOpen(false)}>Service</a>
        </li>
        <li className="cart-icon-wrapper" onClick={() => { navigate('/cart'); setMobileMenuOpen(false); }}>
          <FiShoppingCart className="cart-icon" />
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </li>

        <li onClick={() => { navigate('/contact'); setMobileMenuOpen(false); }}>
          <span className="contact-btn">Contact</span>
        </li>

      </ul>
    </nav>
  );
};

export default Navbar;
